import { Box } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { FormikProps } from "formik";
import * as React from "react";
import { useAppSelector } from "../../app/hooks";
import { selectConstants } from "./Api/constantSlice";
import { DropdownDto } from "./Api/Models";
import { ErrorBox } from "../custom/ErrorBox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface Props {
  formik: FormikProps<any>;
  isDisabled: boolean;
}

export default function DeclineReasons({ formik, isDisabled }: Props) {
  const selData = useAppSelector(selectConstants);

  const handleChange = (event: SelectChangeEvent) => {
    const {
      target: { value },
    } = event;

    formik.setFieldValue(
      "declineReasonId",
      typeof value === "string" ? value.split(",").map(Number) : value
    );
  };

  return (
    <>
      {selData.constantState.applicationDeclineReasons && (
        <FormControl fullWidth>
          <InputLabel id="demo-multiple-checkbox-label">Select Decline Reason</InputLabel>
          <Select
          name='declineReasonId'
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={formik.values.declineReasonId}
            onChange={handleChange}
            input={<OutlinedInput label="Select Decline Reason" />}
            onBlur={formik.handleBlur}
            error={
              formik.touched.businessType && Boolean(formik.errors.businessType)
            }
            renderValue={(selected: any) =>
              selected
                .map(
                  (id: any) =>
                    selData.constantState.applicationDeclineReasons.find(
                      (item) => item.id === id
                    )?.description
                )
                .join(", ")
            }
            MenuProps={MenuProps}
          >
            {selData.constantState.applicationDeclineReasons.map(
              (item: DropdownDto, key: number) => (
                <MenuItem key={key} value={item.id}>
                  <Checkbox
                    checked={formik.values.declineReasonId.includes(item.id)}
                  />
                  <ListItemText primary={item.description} />
                </MenuItem>
              )
            )}
          </Select>
        </FormControl>
      )}

<ErrorBox>
{formik.touched.declineReasonId &&
          (formik.errors.declineReasonId as React.ReactNode)}
                    </ErrorBox>
      
    </>
  );
}
